import './App.css';
import { Home } from './Pages/Home/Home';
import { About } from './Pages/About/About';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from './Components/Navbar/Navbar';
import { Footer } from './Components/Footer/Footer';
import Teachers from './Pages/Teachers/Teachers';
import { GalleryPage } from './Pages/GalleryPage/GalleryPage';

function App() {

  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/teachers' element={<Teachers />} />
          <Route path='/gallery' element={<GalleryPage />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;